import React, { useState } from "react";

import Tab from "../components/Tab";
import EmpresasOpticas from "./EmpresasOpticas";
import AgentesPermisos from "./AgentesPermisos";
import PerfilesControlInformacion from "./PerfilesControlInformacion";
import PredeterminadosPaciente from "./PredeterminadosPaciente";
import Fidelizacion from "./Fidelizacion";

import "../../css/Patient.css";
import "../../css/Panel.css";

import "../css/Settings.css";
import AdministrationSettingsScreen from "./AdministrationSettingsScreen";
import PatientsSettingsScreen from "./PatientsSettingsScreen";
import SalesSettingsScreen from "./SalesSettingsScreen";
import StoreSettingsScreen from "./StoreSettingsScreen";
import CRMSettingsScreen from "./CRMSettingsScreen";
import HardwareSettingsScreen from "./HardwareSettingsScreen";
import SecuritySettingsScreen from "./SecuritySettingsScreen";

export default function Settings(props) {
  const [selectedTab, setSelectedTab] = useState(0);

  if (!props.show) {
    return <></>;
  }

  return (
    <div className="patient-data" id="settings">
      <div className="patient-data-header">
        <span className="header-text">Configuración</span>
      </div>
      <div className="patient-data-content">
        <div className="action-bar">
          <div className="action-bar-resume">
            <span>Configuración</span>
            <span>|</span>
            <span className="signed-text">Ajustes del sistema</span>
          </div>
        </div>
        <div className="settings-panel">
          <div className="settings-tab-container">
            <Tab
              text="Administración"
              icon="/images/settings/oficina.svg"
              selected={selectedTab === 0}
              onClick={() => setSelectedTab(0)}
            />
            <Tab
              text="Pacientes"
              icon="/images/settings/los-usuarios.svg"
              selected={selectedTab === 1}
              onClick={() => setSelectedTab(1)}
            />
            <Tab
              text="Ventas"
              icon="/images/settings/llave.svg"
              selected={selectedTab === 2}
              onClick={() => setSelectedTab(2)}
            />
            <Tab
              text="Almacén"
              icon="/images/settings/pacientes.svg"
              selected={selectedTab === 3}
              onClick={() => setSelectedTab(3)}
            />
            <Tab
              text="CRM"
              icon="/images/settings/pacientes.svg"
              selected={selectedTab === 4}
              onClick={() => setSelectedTab(4)}
            />
            <Tab
              text="Hardware"
              icon="/images/settings/pacientes.svg"
              selected={selectedTab === 5}
              onClick={() => setSelectedTab(5)}
            />
            <Tab
              text="Seguridad"
              icon="/images/settings/llave.svg"
              selected={selectedTab === 6}
              onClick={() => setSelectedTab(6)}
            />
          </div>
          <div className="settings-body">
            <AdministrationSettingsScreen {...props} show={selectedTab === 0} />
            <PatientsSettingsScreen {...props} show={selectedTab === 1} />
            <SalesSettingsScreen {...props} show={selectedTab === 2} />
            <StoreSettingsScreen {...props} show={selectedTab === 3} />
            <CRMSettingsScreen {...props} show={selectedTab === 4} />
            <HardwareSettingsScreen {...props} show={selectedTab === 5} />
            <SecuritySettingsScreen {...props} show={selectedTab === 6} />
          </div>
        </div>
      </div>
    </div>
  );

  /* return (
    <div className="patient-data" id="settings">
      <div className="patient-data-header">
        <span className="header-text">Configuración</span>
      </div>
      <div className="patient-data-content">
        <div className="action-bar">
          <div className="action-bar-resume">
            <span>Configuración</span>
            <span>|</span>
            <span className="signed-text">Ajustes del sistema</span>
          </div>
        </div>
        <div className="settings-panel">
          <div className="settings-tab-container">
            <Tab
              text="Empresas y ópticas"
              icon="/images/settings/oficina.svg"
              selected={selectedTab === 0}
              onClick={() => setSelectedTab(0)}
            />
            <Tab
              text="Agentes y permisos"
              icon="/images/settings/los-usuarios.svg"
              selected={selectedTab === 1}
              onClick={() => setSelectedTab(1)}
            />
            <Tab
              text="Perfiles control de información"
              icon="/images/settings/llave.svg"
              selected={selectedTab === 2}
              onClick={() => setSelectedTab(2)}
            />
            <Tab
              text="Predeterminados de paciente"
              icon="/images/settings/pacientes.svg"
              selected={selectedTab === 3}
              onClick={() => setSelectedTab(3)}
            />
            <Tab
              text="Perfiles de fidelización"
              icon="/images/settings/pacientes.svg"
              selected={selectedTab === 4}
              onClick={() => setSelectedTab(4)}
            />
          </div>
          <div className="settings-body">
            <EmpresasOpticas {...props} show={selectedTab === 0} />
            <AgentesPermisos {...props} show={selectedTab === 1} />
            <PerfilesControlInformacion {...props} show={selectedTab === 2} />
            <PredeterminadosPaciente {...props} show={selectedTab === 3} />
            <Fidelizacion {...props} show={selectedTab === 4} />
          </div>
        </div>
      </div>
    </div>
  );*/
}
